import styled from 'styled-components';

export const TimeIndicator = styled.div<{ top?: string }>`
  position: absolute;
  left: 0;
  top: ${(props) => props.top ?? 0};
  z-index: 1;
  width: 100%;
  height: 0;
  border-top: 2px solid ${({ theme }) => theme.palette.secondary.main};
`;
export const Circle = styled.div`
  width: 20px;
  height: 20px;
  background: ${({ theme }) => theme.palette.secondary.main};
  border-radius: 20px;
  transform: translate(-50%, calc(-50% - 1px));
`;
